import React from 'react';
import {
  Box, Chip, Grid, Paper, Stack, Typography,
} from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { BieMoney } from '../bie/BieValue';

type Props = {
  executive?: any;
  dirty?: boolean;
  stale?: boolean;
};

class SimulationImpactBar extends React.PureComponent<Props> {
  private metric(label: string, value: any, tone?: string) {
    return (
      <Grid size={{ xs: 6, sm: 4, md: 2 }} key={label}>
        <Box sx={{ px: 1.5, py: 1 }}>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            {label}
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 900,
              whiteSpace: 'nowrap',
              color: tone ? `${tone}.main` : 'text.primary',
            }}
          >
            <BieMoney value={value ?? 0} />
          </Typography>
        </Box>
      </Grid>
    );
  }

  render() {
    const d = this.props.executive || {};
    const pending = Boolean(this.props.dirty || this.props.stale);

    return (
      <Paper
        variant="outlined"
        sx={{
          overflow: 'hidden',
          borderWidth: 1,
        }}
      >
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={1}
          sx={{ px: 1.5, py: 1, bgcolor: 'background.default' }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <TrendingUpIcon color="success" fontSize="small" />
            <Typography variant="subtitle2" sx={{ fontWeight: 900 }}>
              Scenario Impact
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Key computed outcomes remain visible while you work.
            </Typography>
          </Stack>

          {pending ? (
            <Chip
              size="small"
              icon={<WarningAmberIcon />}
              color="warning"
              variant="outlined"
              label="Pending changes — values shown are from the last recompute"
            />
          ) : (
            <Chip size="small" color="success" variant="outlined" label="Computed scenario" />
          )}
        </Stack>

        <Grid container sx={{ borderTop: 1, borderColor: 'divider' }}>
          {this.metric('Revenue', d.revenue)}
          {this.metric('Cost of Sales', d.costofsales ?? d.cost)}
          {this.metric('Gross Margin', d.margin, Number(d.margin || 0) >= 0 ? 'success' : 'error')}
          {this.metric('Partial Result', d.partialresult, Number(d.partialresult || 0) >= 0 ? 'success' : 'error')}
          {this.metric('Economic Capacity', d.economiccapacity, 'info')}
          {this.metric('Available Budget', d.availablebudget, Number(d.availablebudget || 0) >= 0 ? 'success' : 'error')}
        </Grid>
      </Paper>
    );
  }
}

export default SimulationImpactBar;
